// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q-radio__bg path{color:#ed885c!important}.error-message{color:#c10015;transition:all .3s ease-in-out;font-size:12px}.q-select .q-field__input{min-width:250px!important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
